export const fmtThousands = (v) => { const n = String(v ?? "").replace(/[^\d]/g, ""); return n ? n.replace(/\B(?=(\d{3})+(?!\d))/g, "\u202f") : ""; };
export const price = (l) => Number(l.list_price_ttc ?? l.price_ttc ?? l.prix_ttc ?? l.price) || 0;
/** Répartition d'un crédit total au prorata des prix nets par lot (dernier lot absorbe l'arrondi). */
export const splitCredit = (lots, totalCredit, lotPrices) => {
  const sum = lots.reduce((a, l) => a + (lotPrices[l.id] || 0), 0);
  if (!sum || !totalCredit) return Object.fromEntries(lots.map((l) => [l.id, 0]));
  const out = {}; let acc = 0;
  lots.forEach((l, i) => { const v = i === lots.length - 1 ? Math.round(totalCredit - acc) : Math.round(totalCredit * (lotPrices[l.id] || 0) / sum); out[l.id] = Math.max(0, v); acc += v; });
  return out;
};

/** iter465 23 — remise d'UN lot : {mode: "amount"|"percent", value: string} → montant DA borné (≤ TTC du lot). */
export const lotDiscountAmount = (ttc, d) => {
  if (!d || d.value === "" || d.value == null) return 0;
  const v = Number(d.value) || 0;
  return Math.min(ttc, Math.max(0, d.mode === "percent" ? Math.round(ttc * v) / 100 : v));
};
/** Changement d'unité : même remise, convertie (% arrondi à 2 décimales). */
export const convertLotDiscount = (ttc, d, mode) => {
  if (!d || d.mode === mode) return { ...(d || {}), mode };
  const amt = lotDiscountAmount(ttc, d);
  if (!amt) return { mode, value: d.value === "" ? "" : "0" };
  return mode === "percent" ? { mode, value: String(Math.round(amt / ttc * 10000) / 100) } : { mode, value: String(Math.round(amt)) };
};
/** Remises par lot initiales : `lot_discounts` du brouillon, sinon l'ancienne remise globale portée par le premier lot (rien n'est réécrit). */
export const initLotDiscounts = (draft, lots) => {
  const ld = draft?.lot_discounts;
  if (ld && typeof ld === "object" && Object.keys(ld).length) return Object.fromEntries(Object.entries(ld).map(([k, v]) => [k, { mode: v.mode === "percent" ? "percent" : "amount", value: v.value == null ? "" : String(v.value) }]));
  if (draft?.discount && lots[0]) return { [lots[0].id]: { mode: draft.discount.mode === "percent" ? "percent" : "amount", value: String(draft.discount.value) } };
  return {};
};

/** iter467 28.3 — retire UN fichier (stocké ou « À envoyer ») d'une valeur de document ; null si plus rien. */
export const dropFile = (v, f) => {
  if (!v) return null;
  if (v instanceof File) return v === f ? null : v;
  const files = (v.files || (v.file_id ? [v] : [])).filter((x) => !(f?.file_id && x.file_id === f.file_id));
  const pendingAdd = (v.pendingAdd || []).filter((x) => x !== f);
  if (!files.length && !pendingAdd.length) return null;
  if (!files.length) return { pendingAdd };
  return { ...files[0], files, pendingAdd };
};
